export class Locale {
  private _country: string
  private _language: string

  constructor(locale: string) {
    [this._language, this._country] = (locale || '').split('_')
  }

  get country(): string {
    return this._country
  }

  get language(): string {
    return this._language
  }
}
